import type { TriggerActionEventName } from '@ori/shopping-context';

export * from '../constants-generated';
export * from './defaultTranslations';
export * from './styles';

// event actions monitored by loading state of the shopping context provider
export const eventNames: TriggerActionEventName[] = ['add-to-basket', 'remove-basket-item', 'update-basket-item'];
